import React from "react";
import PropTypes from "prop-types";
import {Button, Dialog, DialogActions, makeStyles, TextField, Tooltip} from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import Divider from "@material-ui/core/Divider";
import DialogContent from "@material-ui/core/DialogContent";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";

const useStyles = makeStyles(() => ({
    inputRoot: {
        width: 100,
        paddingRight: 15,

        '&[class*="MuiInput-root"]': {
            paddingBottom: 1,
            '& $input': {
                padding: 1,
            },
            '& input:first-child': {
                padding: '3px 0 1px !important',
                marginRight: 3,
            },
        },
    },
    clearIndicator: {
        display: 'none',
    },
    paper: {
        width: '200px',
    },
    endAdornment: {
        position: 'absolute',
        right: 0,
        top: 'calc(50% - 14px)',
    },
    popupIndicator: {
        padding: 2,
        marginRight: -2,
    },
    noOptions: {
        padding: '14px 16px',
    },
    option: {
        minHeight: 5,
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        cursor: 'pointer',
        paddingTop: 2,
        boxSizing: 'border-box',
        outline: '0',
        WebkitTapHighlightColor: 'transparent',
        paddingBottom: 2,
        paddingLeft: 16,
        paddingRight: 16,
    },
    formControl: {width: '100%'}
}))

const CustomFrequency = (props) => {
    return (
        <Dialog open={props.isCustomFrequencyOpen} id='frequencyDialog'
                onClose={props.closeCustom}
                aria-labelledby="form-dialog-title">
            <DialogTitle id="form-dialog-title">Frequency</DialogTitle>
            <Divider variant="fullWidth"/>
            <DialogContent>
                <form id={'frequencyForm'} onSubmit={props.onCompleteFrequency}>
                    <RepeatEvery
                        values={props.values}
                        onChangeEvery={props.onChangeEvery}
                        onChangeType={props.onChangeType}
                        frequencyTypeList={props.frequencyTypeList}
                    />
                    {props.values.type && props.values.type.id === 'WEEK' && (
                        <RepeatOn
                            values={props.values}
                            daysOfWeek={props.daysOfWeek}
                            onChangeTypeDays={props.onChangeTypeDays}
                        />
                    )}
                    {props.values.type && props.values.type.id === 'MONTH' && (
                        <DayOfMonth
                            values={props.values}
                            onChangeCustomFields={props.onChangeCustomFields}
                        />
                    )}
                    <Start
                        values={props.values}
                        onChangeCustomFields={props.onChangeCustomFields}
                    />
                    <SetTime
                        values={props.values}
                        onChangeCustomFields={props.onChangeCustomFields}
                        required={props.timeRequired}
                    />
                    <EndsOn
                        values={props.values}
                        onChangeCustomFields={props.onChangeCustomFields}
                        onChangeRadio={props.onChangeRadio}
                        checked={props.checked}
                    />
                </form>
            </DialogContent>

            <DialogActions>
                <Button variant={"contained"}
                        type={'submit'}
                        size={'small'}
                        id={"saveFrequency"}
                        form={'frequencyForm'}
                        color={"primary"}>
                    Save
                </Button>
                <Button
                    variant={"contained"}
                    color={"default"}
                    size={'small'}
                    onClick={props.closeCustom}>
                    Cancel
                </Button>
            </DialogActions>

        </Dialog>
    )
};


const RepeatEvery = (props) => {
    const classes = useStyles();
    return (
        <div style={{display: 'flex'}}>
            <label style={{
                marginRight: 20
            }}>Repeat Every</label>
            <TextField
                style={{marginRight: '20px'}}
                autoFocus={true}
                type={'number'}
                variant={"outlined"}
                value={props.values.every || ''}
                name="every"
                onChange={props.onChangeEvery}
                inputProps={{
                    style: {width: 50, padding: 3},
                    min: 0
                }}
            />

            <Autocomplete
                getOptionLabel={option => props.values.every > 1 ? option.plural : option.singular}
                options={props.frequencyTypeList}
                onChange={props.onChangeType}
                autoHighlight={true}
                clearOnEscape={true}
                filterSelectedOptions
                //inputValue={props.values.every < 2 ? props.values.type.singular : props.values.type.plural}
                //onInputChange={this.onInputChange}
                value={props.values.type || ''}
                classes={{
                    inputRoot: classes.inputRoot,
                    paper: classes.paper,
                    clearIndicator: classes.clearIndicator,
                    endAdornment: classes.endAdornment,
                    popupIndicator: classes.popupIndicator,
                    option: classes.option,
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                    />
                )}
            />
        </div>
    )
};

const RepeatOn = (props) => {
    const {daysOfWeek, onChangeTypeDays, values: {dayOfWeek}} = props;
    const classes = useStyles();

    return (
        <div style={{marginTop: 10}}>
            <label>Repeat On</label>
            <div style={{display: 'flex', alignItems: 'center', gap: 10, marginTop: 8,}}>
                {daysOfWeek.map(dayOfWeekV => {
                    let isSelected = dayOfWeek?.find(v => v._id === dayOfWeekV._id)
                    return (
                        <Tooltip title={dayOfWeekV.name} key={dayOfWeekV.name}>
                            <div
                                style={{
                                    padding: 3,
                                    height: 25, width: 25,
                                    fontSize: 12,
                                    borderRadius: '50%',
                                    background: isSelected ? '#1b4d91' : '#CDD8E7',
                                    color: isSelected ? '#fff' : '#000',
                                    display: 'flex', justifyContent: 'center', alignItems: 'center',
                                    cursor: 'pointer'
                                }}
                                onClick={e => onChangeTypeDays(e, dayOfWeekV)}>
                                {dayOfWeekV?.name?.charAt(0).toUpperCase()}
                            </div>
                        </Tooltip>
                    )
                })}
            </div>
        </div>

    )
    return (
        <div style={{marginTop: 20, display: 'flex'}}>
            <label style={{
                marginRight: 27,
            }}>Repeat On</label>

            <Autocomplete
                getOptionLabel={option => option.name}
                options={props.daysOfWeek}
                onChange={props.onChangeTypeDays}
                autoHighlight={true}
                value={props.values.dayOfWeek || ''}
                classes={{
                    inputRoot: classes.inputRoot,
                    paper: classes.paper,
                    endAdornment: classes.endAdornment,
                    clearIndicator: classes.clearIndicator,
                    popupIndicator: classes.popupIndicator,
                    option: classes.option,
                }}
                disableClearable
                renderInput={params => (
                    <TextField
                        {...params}
                    />
                )}
            />
        </div>
    )
};

const DayOfMonth = (props) => {
    return (
        <div style={{
            marginTop: 20,
        }}>
            <label style={{
                marginRight: 10
            }}>Day Of Month</label>
            <TextField
                type={'number'}
                name={'dayOfMonth'}
                value={props.values.dayOfMonth || ''}
                onChange={props.onChangeCustomFields}
                variant={"outlined"}
                inputProps={{
                    style: {width: 50, padding: 3},
                    min: 1,
                    max: 31
                }}
            />
        </div>

    )
};

const Start = (props) => {
    return (
        <div style={{
            marginTop: 20,
        }}>
            <label style={{
                marginRight: 78
            }}>Start</label>
            <TextField
                type={'date'}
                name={'start'}
                value={props.values.start || ''}
                onChange={props.onChangeCustomFields}
                variant={"outlined"}
                inputProps={{
                    style: {padding: 3}
                }}
            />
        </div>
    )
};

const EndsOn = (props) => {
    return (
        <div style={{marginTop: 20}}>
            <label>Ends</label>
            <br/>
            <div style={{marginTop: 10, marginLeft: 8}}>
                <FormControlLabel style={{marginTop: 5}} value="none" control={
                    <Radio style={{padding: 3}} onChange={props.onChangeRadio}
                           name="after" checked={props.checked === 'none'}/>} label="Never"/>
                <br/>
                <FormControlLabel
                    style={{marginTop: 5}} value="on" control={
                    <Radio style={{padding: 3}}
                           onChange={props.onChangeRadio}
                           name="after"
                           checked={props.checked === 'on'}
                    />}
                    label="On"/>
                <TextField
                    style={{marginTop: 5, marginLeft: 29, width: 200}}
                    disabled={props.checked === 'after' || props.checked === 'none'}
                    className={'form-dynamic'}
                    name={'endsOn'}
                    onChange={props.onChangeCustomFields}
                    value={props.values.endsOn || ''}
                    variant={"outlined"}
                    type={'date'}
                />
                <br/>
                <FormControlLabel style={{marginTop: 5}} value="after" control={
                    <Radio style={{padding: 3}}
                           onChange={props.onChangeRadio}
                           name="after"
                           checked={props.checked === 'after'}
                    />}
                                  label="After"
                />
                <TextField
                    style={{marginTop: 5, marginLeft: 12, width: 200}}
                    className={'form-dynamic'}
                    name={'maxIterations'}
                    onChange={props.onChangeCustomFields}
                    value={props.values.maxIterations || ''}
                    variant={"outlined"}
                    type={'number'}
                    inputProps={{
                        min: 1
                    }}
                    disabled={props.checked === 'on' || props.checked === 'none'}
                />
                <br/>
            </div>
        </div>
    )
};

const SetTime = (props) => {
    const classes = useStyles();
    return (
        <div style={{display: 'flex', marginTop: 10}}>
            <label style={{
                marginRight: 54
            }}>Set Time</label>
            <TextField
                style={{marginRight: '20px'}}
                required={props.required}
                type={'time'}
                variant={"outlined"}
                value={props.values.time || ''}
                name="time"
                onChange={props.onChangeCustomFields}
                inputProps={{
                    style: {width: 141, padding: 3},
                    min: 0
                }}
            />
        </div>
    )
};

CustomFrequency.propTypes = {
    isCustomFrequencyOpen: PropTypes.bool,
    values: PropTypes.object,
    frequencyTypeList: PropTypes.array,
    closeCustom: PropTypes.func,
    onCompleteFrequency: PropTypes.func,
    onChangeEvery: PropTypes.func,
    onChangeType: PropTypes.func,
    onChangeCustomFields: PropTypes.func,
    onChangeRadio: PropTypes.func,
    checked: PropTypes.string
}
CustomFrequency.defaultProps = {
    values: {}
}
export default CustomFrequency
